import React from 'react'
import Spinner from '../Spinner/Spinner'
import Tout from '../Tout/Tout'
import LoadingPage from '../LoadingPage/LoadingPage'
import defaultBannerTout from './defaultBannerTout'

import variables from './CasinoLayoutSkeleton.scss'
import '../TopBar/TopBarLogo/styles/topBarLogo.scss'

/**
 * @description This component can be rendered before state, i18n, configs are available so it cannot directly depend on components with such dependencies.
 */
function CasinoLayoutSkeleton() {
  const showLobbySkeleton = window.location.pathname.includes('casino/lobby')

  return showLobbySkeleton ? (
    <div id="lobby-outer" className="casino-layout-skeleton">
      <div id="lobby-inner" className="lobby-inner disable-secondary-nav">
        {/* Navbar placeholder */}
        <nav id="navbar" className="navbar fixed-top navbar-dark navbar-expand-md disable-secondary-nav">
          {/* Logo placeholder */}
          <div>
            <picture className="logo disable-secondary-nav">
              <source
                media="(max-width: 55rem)"
                srcSet={`${process.env.PUBLIC_URL}/${process.env.REACT_APP_CASINO_IMAGE_PATH}/${variables.headerLogoMobile} 26w`}
                sizes="1.625rem"
              />
              <source
                srcSet={`${process.env.PUBLIC_URL}/${process.env.REACT_APP_CASINO_IMAGE_PATH}/${variables.headerLogo} 163w`}
                sizes="10.2rem"
              />
              <img
                src={`${process.env.PUBLIC_URL}/${process.env.REACT_APP_CASINO_IMAGE_PATH}/${variables.headerLogo}`}
                alt={'High 5 Logo'} /** Translations not available yet. */
                className="skeleton-logo-img"
              />
            </picture>
          </div>
        </nav>
        <div className="navbar-top-padding fixed-top" />

        <main>
          {/* Slider (banners) placeholder */}
          <div className="mt">
            <Tout parentKey={0} toutData={defaultBannerTout} isParallax={false} onAction={() => {}} isBanner={true} />
          </div>

          {/* Categories placeholder */}
          <div className="categories"></div>

          {/* Game list placeholder */}
          <div className="game-list">
            <Spinner />
          </div>
        </main>
      </div>
    </div>
  ) : (
    <LoadingPage />
  )
}

export default CasinoLayoutSkeleton
